/**
 * Central brand asset config — Brand v1.0 FINAL + official Drive assets.
 *
 * Swap paths here to update every UI surface. Do not hard-code brand
 * paths elsewhere in the codebase.
 */

// Primary lockup — CLEAN transparent PNG (background removed via rembg).
// -on-dark  → ice/arch-white letters on transparent, use on dark surfaces
// -on-light → navy/steel letters on transparent, use on light surfaces
export const BRAND_LOGO_URL = "/brand/logo/df-primary-on-dark.png";
export const BRAND_LOGO_ON_DARK_URL = "/brand/logo/df-primary-on-dark.png";
export const BRAND_LOGO_ON_LIGHT_URL = "/brand/logo/df-primary-on-light.png";
export const BRAND_LOGO_LIGHT_URL = "/brand/logo/df-primary-on-light.png";  // alias
export const BRAND_LOGO_MONOGRAM_URL = "/brand/logo/df-monogram-on-dark.png";
export const BRAND_LOGO_MONOGRAM_ON_DARK_URL = "/brand/logo/df-monogram-on-dark.png";
export const BRAND_LOGO_MONOGRAM_ON_LIGHT_URL = "/brand/logo/df-monogram-on-light.png";

// Icon set (favicon + PWA)
export const BRAND_ICON_URL = "/brand/logo/df-icon-192.png";
export const BRAND_ICON_512_URL = "/brand/logo/df-icon-512.png";
export const BRAND_APPLE_TOUCH_URL = "/apple-touch-icon.png";

// Photography (official) — key/value used across the app
export const BRAND_PHOTO = {
    welcome: "/brand/photography/welcome.jpg",
    vision: "/brand/photography/vision.jpg",
    development: "/brand/photography/development.jpg",
    construction: "/brand/photography/construction.jpg",
    capital: "/brand/photography/capital.jpg",
    communities: "/brand/photography/communities.jpg",
    innovation: "/brand/photography/innovation.jpg",
    forgeosLaunch: "/brand/photography/forgeos-launch.jpg",
    forgeosPlatform: "/brand/photography/forgeos-platform.jpg",
    forgeosIphone: "/brand/photography/forgeos-iphone.jpg",
    projects: "/brand/photography/projects.jpg",
    letsBuild: "/brand/photography/lets-build.jpg",
};

// Palette — sampled from the official primary-light logo file.
// Steel Blue lives inside the "F" of the DF monogram (metallic mid-tone).
export const BRAND_COLORS = {
    navy: "#0F2747",
    steelBlue: "#5B7FB0",
    steelBlueLight: "#8AA3CC",
    steelBlueDark: "#3D5A85",
    ice: "#DCEEFF",
    obsidian: "#111315",
    archWhite: "#F7F7F4",
};
